import { getUserProfile } from 'utilities/AuthService';
import { UserProfile, UserRole } from '../types/user';

function checkRole(user: UserProfile, role: UserRole) {
  
  return user.Role.includes(role);
}

export function userHasRoles(roles: Array<UserRole>): boolean {
  const user = getUserProfile();

  if (!user) return false;

  const checks = roles.map((role) => checkRole(user, role));

  return checks.every((check) => check === true);
}

export function userHasOneOfRoles(roles: Array<UserRole>): boolean {
  const user = getUserProfile();

  if (!user) return false;

  const checks = roles.map((role) => checkRole(user, role));

  return checks.find((check) => check === true) !== undefined;
}
